import { withRouter } from "react-router-dom";
import { useEffect } from "react";

function ScrollToTop({ location }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

export default withRouter(ScrollToTop);